import { useState } from 'react'

// local imports
import ParkAreaService from 'service/ParkAreaService'
import { IAvailableParkAreas } from 'types/ParkAreaType'

export default function useGetParkAreaList() {
  const [availableParkAreas, setAvailableParkAreas] = useState<IAvailableParkAreas | null>(null)
  const [loading, setLoading] = useState(false)

  /* Get Park Area List */
  const getParkAreaList = (data: any) => {
    setLoading(true)
    ParkAreaService.getAvailableParkAreaList(data)
      .then((r) => setAvailableParkAreas(r.data))
      .catch((err) => {
        console.log(err)
        setAvailableParkAreas(null)
      })
      .finally(() => setLoading(false))
  }

  return { availableParkAreas, getParkAreaList, loading }
}
